import { defineMessages } from 'react-intl';

export const freightActionButtonMessages = defineMessages({
  newQuote: {
    id: 'azHWN3',
    description: 'Button to start a new LTL freight quote',
    defaultMessage: 'Browse Rates',
  },
  createFreightShipment: {
    id: 'uIhcQ8',
    description: 'Button to launch the freight booking wizard directly to create a new LTL freight shipment',
    defaultMessage: 'Create Freight Shipment',
  },
  trackFreight: {
    id: '3F6N7p',
    description: 'Track freight shipment button label',
    defaultMessage: 'Refresh Tracking',
  },
  downloadBol: {
    id: '31KxVA',
    description: 'Download BOL button label',
    defaultMessage: 'Download BOL',
  },
  print: {
    id: 'uuaf5H',
    description: 'Print dropdown button label for freight documents',
    defaultMessage: 'Print',
  },
  billOfLading: {
    id: 'IjtPtC',
    description: 'Bill of Lading document type menu item',
    defaultMessage: 'Bill of Lading',
  },
  packingList: {
    id: 'mUziEA',
    description: 'Packing List document type menu item',
    defaultMessage: 'Packing List',
  },
  palletLabels: {
    id: 'MgT7+9',
    description: 'Pallet Labels document type menu item',
    defaultMessage: 'Pallet Labels',
  },
  rateQuote: {
    id: 'FqdZwL',
    description: 'Rate Quote document type menu item',
    defaultMessage: 'Rate Quote',
  },
  cancelFreight: {
    id: 'lD2tKZ',
    description: 'Delete freight quote button label',
    defaultMessage: 'Delete',
  },
  voidFreight: {
    id: 'V8l1Kv',
    description: 'Void booked freight button label',
    defaultMessage: 'Void',
  },
  voidConfirmHeader: {
    id: 'w49FMA',
    description: 'Header for the confirm dialog shown before voiding booked freight',
    defaultMessage: 'Void freight booking?',
  },
  voidConfirmBody: {
    id: 'IRz4t5',
    description: 'Body text for the confirm dialog shown before voiding booked freight',
    defaultMessage: 'Voiding cancels the selected freight bookings with the carrier. This cannot be undone.',
  },
  voidConfirmButton: {
    id: '5Z4/wq',
    description: 'Confirm button label in the void freight confirmation dialog',
    defaultMessage: 'Void',
  },
  newQuoteDisabledTooltip: {
    id: 'm0w3cF',
    description: 'Tooltip shown when New Quote button is disabled because no freight provider is connected',
    defaultMessage: 'Connect a freight provider first',
  },
  freightBookDisabledTooltip: {
    id: '3ekew2',
    description: 'Tooltip shown when a freight action button is disabled because the user lacks the Freight Book permission',
    defaultMessage: 'Requires the Freight: Book Shipments permission',
  },
  voidNonBookedDisabledTooltip: {
    id: 'ZmCXKW',
    description:
      'Tooltip shown when the Void button is disabled because the selection includes shipments already in transit, delivered, or in exception',
    defaultMessage: 'Only shipments that have not been picked up can be voided',
  },
  orderManagementDisabledTooltip: {
    id: '4/wT0L',
    description: 'Tooltip shown when the Export button is disabled because the user lacks the OrderManagement permission',
    defaultMessage: 'Requires the Order Management permission',
  },
  export: {
    id: 'XfdtcI',
    description: 'Export button label for freight shipments, also used as the export modal confirm-button label',
    defaultMessage: 'Export',
  },
  importFreight: {
    id: '8Lw0Si',
    description: 'Import freight shipments from CSV button label',
    defaultMessage: 'Import',
  },
  selectAtLeastOneColumn: {
    id: 'X+TvbA',
    description: 'Validation shown when the user tries to save the freight grid columns with every column deselected',
    defaultMessage: 'Select at least one column to show on the freight grid.',
  },
});
